import React from 'react';
import { FoodOrder as UIFoodOrder } from '@shopee/chatbot-ui';
import { FoodOrderProps, FoodOrderServiceType } from '@shopee/chatbot-ui/lib/components/FoodOrder';
import dateLib from '@/utils/dateLib/moment';
import { getDriverOrderCode } from './OrderCardWithButton';


const FoodOrder = (props: FoodOrderProps) => {
  const {
    order_id,
    banner_type,
    delivery_status,
    shop_name,
    delivery_location = {},
    create_time,
    buyer_info,
    service_type,
    pickup_location,
  } = props as any;

  const propsFromUnderScoreCase = {
    orderId: order_id,
    bannerType: banner_type,
    status: delivery_status,
    shopName: service_type === FoodOrderServiceType.Food ? shop_name : pickup_location?.address,
    buyerInfo: buyer_info || delivery_location?.address || '',
    createTime: dateLib.format(create_time, 'HH:ii DD MMM YYYY'),
    orderCode: getDriverOrderCode(props as any) as string,
  };
  return <UIFoodOrder {...{ ...propsFromUnderScoreCase, ...props }} wrapperStyle={{ minWidth: 'unset' }}/>;
};

export default FoodOrder;
